import styled from 'styled-components';

export const Header = styled.div`
  height: ${({ theme }) => theme.spacing.x16};
  width: 100%;
  background: ${({ theme }) => theme.palette.white};
  padding: ${({ theme }) => `${theme.spacing.x2} ${theme.spacing.x8}`};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    height: 92px;
    box-shadow: ${({ theme }) => theme.boxShadow.md};
    padding: ${({ theme }) => `${theme.spacing.x2}`};
  }
`;

export const HeaderRow = styled.div`
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-wrap: wrap;
  }
`;
export const Hamber = styled.div`
  display: none;
`;

export const IconButton = styled.div``;

export const User = styled.div`
  margin-inline-end: ${({ theme }) => theme.spacing.x4};
  white-space: nowrap;
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    text-align: center;
  }
`;

export const Key = styled.div`
  font-size: ${({ theme }) => theme.fs.xxs};
  font-weight: 300;
`;

export const RightBox = styled.div`
  flex-grow: 1;

  @media (max-width: ${({ theme }) => theme.media.md}) {
    justify-content: space-between;
  }
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    order: 2;
    margin: ${({ theme }) => theme.spacing.x3} 0 0;
  }
`;
